export function defaultDataForInvoice(name="", address1="", address2="", town="", country="", postcode="") {
    const lines = [
        address1,
        address2,
        town,
        country,
        postcode,
    ];

    const addressBlock = lines.filter(line => line && line.trim() !== '').join('\n');

return `
${name}
${addressBlock}

Dear ${name},

Please find enclosed the invoice for the upcoming lens replacement surgery scheduled for the 20th
September 2024 as a private patient at Ayrshire Eye Clinic, 3 Broomfield Road, Ayr KA7 2SP.

We would like the fee to be settled prior to the procedure. This can be settled by bank transfer or debit
card payment. For a bank transfer the details are as below. Kindly include your name as reference for
the bank transfer. For a card payment please call 01292 282100.

Please allow 48 hours for bank transfer and 24 hours for debit card payment. Cash payments can be
made on the day of procedure.

Please note, we no longer accept payment by credit card or cheque.

The details for bank transfer are as follows:

Ayrshire Eye Clinic
Royal Bank of Scotland
Sort code: 83-15-26
Account no: 110 75224

Thanking you,

Yours sincerely,


Jennifer Saunders
Surgical Co-ordinator`
}